import { getAdminBaseUrl, getLiveBaseUrl, getPublicBaseUrl } from '@showliner/shared';
import { recalledUtm, sessionStorageOrNull, withUtm } from '@showliner/shared/utils/waitlistSignup';

// Cross-app links derive from the current hostname (see appUrls.ts in shared),
// so they resolve correctly in prod, dev, and local without per-env config.

export function getLiveUrl(path = ''): string {
  return `${getLiveBaseUrl()}${path}`;
}

/**
 * A link into admin. Signup links (`/register…`) carry the campaign tags this
 * visit arrived with, so a closed-beta waitlist request made there records the
 * ad or post that brought the visitor: sessionStorage does not cross origins.
 */
export function getAdminUrl(path = ''): string {
  const url = `${getAdminBaseUrl()}${path}`;
  return path.startsWith('/register') ? withUtm(url, recalledUtm(sessionStorageOrNull())) : url;
}

export function getPublicUrl(path = ''): string {
  return `${getPublicBaseUrl()}${path}`;
}

export function getAssetUrl(path: string): string {
  if (path.startsWith('http')) return path;
  const apiBase = import.meta.env.VITE_API_URL
    || (import.meta.env.DEV ? '' : 'https://api.showliner.io');
  return `${apiBase}${path.startsWith('/') ? path : `/${path}`}`;
}
